export class MediaSubscriptionErrorsModel {
    emptySubscriptionName: boolean = false;
    noIncludeKeywords: boolean = false;
    noHandles: boolean = false;
    tooManyTerms: boolean = false;
    hashtagHasPunctuation: boolean = false;
    duplicateKeywords: boolean = false;
}
